export default [
  { value: 'AED', description: 'United Arab Emirates dirham' },
  { value: 'AFN', description: 'Afghan afghani' },
  { value: 'ALL', description: 'Albanian lek' },
  { value: 'AMD', description: 'Armenian dram' },
  { value: 'AOA', description: 'Angolan kwanza' },
  { value: 'ARS', description: 'Argentine peso' },
  { value: 'AUD', description: 'Australian dollar' },
  { value: 'AWG', description: 'Aruban florin' },
  { value: 'AZN', description: 'Azerbaijani manat' },
  { value: 'BAM', description: 'Bosnia and Herzegovina convertible mark' },
  { value: 'BBD', description: 'Barbados dollar' },
  { value: 'BDT', description: 'Bangladeshi taka' },
  { value: 'BGN', description: 'Bulgarian lev' },
  { value: 'BHD', description: 'Bahraini dinar' },
  { value: 'BIF', description: 'Burundian franc' },
  { value: 'BMD', description: 'Bermudian dollar' },
  { value: 'BND', description: 'Brunei dollar' },
  { value: 'BOB', description: 'Boliviano' },
  { value: 'BOV', description: 'Bolivian Mvdol' },
  { value: 'BRL', description: 'Brazilian real' },
  { value: 'BSD', description: 'Bahamian dollar' },
  { value: 'BTN', description: 'Bhutanese ngultrum' },
  { value: 'BWP', description: 'Botswana pula' },
  { value: 'BYN', description: 'Belarusian ruble' },
  { value: 'BZD', description: 'Belize dollar' },
  { value: 'CAD', description: 'Canadian dollar' },
  { value: 'CDF', description: 'Congolese franc' },
  { value: 'CHE', description: 'WIR euro' },
  { value: 'CHF', description: 'Swiss franc' },
  { value: 'CHW', description: 'WIR franc' },
  { value: 'CLF', description: 'Unidad de Fomento' },
  { value: 'CLP', description: 'Chilean peso' },
  { value: 'CNY', description: 'Renminbi' },
  { value: 'COP', description: 'Colombian peso' },
  { value: 'COU', description: 'Unidad de Valor Real' },
  { value: 'CRC', description: 'Costa Rican colon' },
  { value: 'CUP', description: 'Cuban peso' },
  { value: 'CVE', description: 'Cape Verdean escudo' },
  { value: 'CZK', description: 'Czech koruna' },
  { value: 'DJF', description: 'Djiboutian franc' },
  { value: 'DKK', description: 'Danish krone' },
  { value: 'DOP', description: 'Dominican peso' },
  { value: 'DZD', description: 'Algerian dinar' },
  { value: 'EGP', description: 'Egyptian pound' },
  { value: 'ERN', description: 'Eritrean nakfa' },
  { value: 'ETB', description: 'Ethiopian birr' },
  { value: 'EUR', description: 'Euro' },
  { value: 'FJD', description: 'Fiji dollar' },
  { value: 'FKP', description: 'Falkland Islands pound' },
  { value: 'GBP', description: 'Pound sterling' },
  { value: 'GEL', description: 'Georgian lari' },
  { value: 'GHS', description: 'Ghanaian cedi' },
  { value: 'GIP', description: 'Gibraltar pound' },
  { value: 'GMD', description: 'Gambian dalasi' },
  { value: 'GNF', description: 'Guinean franc' },
  { value: 'GTQ', description: 'Guatemalan quetzal' },
  { value: 'GYD', description: 'Guyanese dollar' },
  { value: 'HKD', description: 'Hong Kong dollar' },
  { value: 'HNL', description: 'Honduran lempira' },
  { value: 'HTG', description: 'Haitian gourde' },
  { value: 'HUF', description: 'Hungarian forint' },
  { value: 'IDR', description: 'Indonesian rupiah' },
  { value: 'ILS', description: 'Israeli new shekel' },
  { value: 'INR', description: 'Indian rupee' },
  { value: 'IQD', description: 'Iraqi dinar' },
  { value: 'IRR', description: 'Iranian rial' },
  { value: 'ISK', description: 'Icelandic króna' },
  { value: 'JMD', description: 'Jamaican dollar' },
  { value: 'JOD', description: 'Jordanian dinar' },
  { value: 'JPY', description: 'Japanese yen' },
  { value: 'KES', description: 'Kenyan shilling' },
  { value: 'KGS', description: 'Kyrgyzstani som' },
  { value: 'KHR', description: 'Cambodian riel' },
  { value: 'KMF', description: 'Comoro franc' },
  { value: 'KPW', description: 'North Korean won' },
  { value: 'KRW', description: 'South Korean won' },
  { value: 'KWD', description: 'Kuwaiti dinar' },
  { value: 'KYD', description: 'Cayman Islands dollar' },
  { value: 'KZT', description: 'Kazakhstani tenge' },
  { value: 'LAK', description: 'Lao kip' },
  { value: 'LBP', description: 'Lebanese pound' },
  { value: 'LKR', description: 'Sri Lankan rupee' },
  { value: 'LRD', description: 'Liberian dollar' },
  { value: 'LSL', description: 'Lesotho loti' },
  { value: 'LYD', description: 'Libyan dinar' },
  { value: 'MAD', description: 'Moroccan dirham' },
  { value: 'MDL', description: 'Moldovan leu' },
  { value: 'MGA', description: 'Malagasy ariary' },
  { value: 'MKD', description: 'Macedonian denar' },
  { value: 'MMK', description: 'Myanmar kyat' },
  { value: 'MNT', description: 'Mongolian tögrög' },
  { value: 'MOP', description: 'Macanese pataca' },
  { value: 'MRU', description: 'Mauritanian ouguiya' },
  { value: 'MUR', description: 'Mauritian rupee' },
  { value: 'MVR', description: 'Maldivian rufiyaa' },
  { value: 'MWK', description: 'Malawian kwacha' },
  { value: 'MXN', description: 'Mexican peso' },
  { value: 'MXV', description: 'Mexican Unidad de Inversion' },
  { value: 'MYR', description: 'Malaysian ringgit' },
  { value: 'MZN', description: 'Mozambican metical' },
  { value: 'NAD', description: 'Namibian dollar' },
  { value: 'NGN', description: 'Nigerian naira' },
  { value: 'NIO', description: 'Nicaraguan córdoba' },
  { value: 'NOK', description: 'Norwegian krone' },
  { value: 'NPR', description: 'Nepalese rupee' },
  { value: 'NZD', description: 'New Zealand dollar' },
  { value: 'OMR', description: 'Omani rial' },
  { value: 'PAB', description: 'Panamanian balboa' },
  { value: 'PEN', description: 'Peruvian sol' },
  { value: 'PGK', description: 'Papua New Guinean kina' },
  { value: 'PHP', description: 'Philippine peso' },
  { value: 'PKR', description: 'Pakistani rupee' },
  { value: 'PLN', description: 'Polish złoty' },
  { value: 'PYG', description: 'Paraguayan guaraní' },
  { value: 'QAR', description: 'Qatari riyal' },
  { value: 'RON', description: 'Romanian leu' },
  { value: 'RSD', description: 'Serbian dinar' },
  { value: 'RUB', description: 'Russian ruble' },
  { value: 'RWF', description: 'Rwandan franc' },
  { value: 'SAR', description: 'Saudi riyal' },
  { value: 'SBD', description: 'Solomon Islands dollar' },
  { value: 'SCR', description: 'Seychelles rupee' },
  { value: 'SDG', description: 'Sudanese pound' },
  { value: 'SEK', description: 'Swedish krona' },
  { value: 'SGD', description: 'Singapore dollar' },
  { value: 'SHP', description: 'Saint Helena pound' },
  { value: 'SLE', description: 'Sierra Leonean leone' },
  { value: 'SOS', description: 'Somalian shilling' },
  { value: 'SRD', description: 'Surinamese dollar' },
  { value: 'SSP', description: 'South Sudanese pound' },
  { value: 'STN', description: 'São Tomé and Príncipe dobra' },
  { value: 'SVC', description: 'Salvadoran colón' },
  { value: 'SYP', description: 'Syrian pound' },
  { value: 'SZL', description: 'Swazi lilangeni' },
  { value: 'THB', description: 'Thai baht' },
  { value: 'TJS', description: 'Tajikistani somoni' },
  { value: 'TMT', description: 'Turkmenistan manat' },
  { value: 'TND', description: 'Tunisian dinar' },
  { value: 'TOP', description: 'Tongan paʻanga' },
  { value: 'TRY', description: 'Turkish lira' },
  { value: 'TTD', description: 'Trinidad and Tobago dollar' },
  { value: 'TWD', description: 'New Taiwan dollar' },
  { value: 'TZS', description: 'Tanzanian shilling' },
  { value: 'UAH', description: 'Ukrainian hryvnia' },
  { value: 'UGX', description: 'Ugandan shilling' },
  { value: 'USD', description: 'United States dollar' },
  { value: 'UYI', description: 'Uruguay Peso en Unidades Indexadas' },
  { value: 'UYU', description: 'Uruguayan peso' },
  { value: 'UYW', description: 'Unidad previsional' },
  { value: 'UZS', description: 'Uzbekistani sum' },
  { value: 'VED', description: 'Venezuelan digital bolívar' },
  { value: 'VES', description: 'Venezuelan sovereign bolívar' },
  { value: 'VND', description: 'Vietnamese đồng' },
  { value: 'VUV', description: 'Vanuatu vatu' },
  { value: 'WST', description: 'Samoan tala' },
  { value: 'XAD', description: 'Arab Accounting Dinar' },
  { value: 'XAF', description: 'CFA franc BEAC' },
  { value: 'XAG', description: 'Silver' },
  { value: 'XAU', description: 'Gold' },
  { value: 'XBA', description: 'European Composite Unit' },
  { value: 'XBB', description: 'European Monetary Unit' },
  { value: 'XBC', description: 'European Unit of Account 9' },
  { value: 'XBD', description: 'European Unit of Account 17' },
  { value: 'XCD', description: 'East Caribbean dollar' },
  { value: 'XCG', description: 'Caribbean guilder' },
  { value: 'XDR', description: 'Special drawing rights' },
  { value: 'XOF', description: 'CFA franc BCEAO' },
  { value: 'XPD', description: 'Palladium' },
  { value: 'XPF', description: 'CFP franc' },
  { value: 'XPT', description: 'Platinum' },
  { value: 'XSU', description: 'SUCRE' },
  { value: 'XUA', description: 'ADB Unit of Account' },
  { value: 'XXX', description: 'No currency' },
  { value: 'YER', description: 'Yemeni rial' },
  { value: 'ZAR', description: 'South African rand' },
  { value: 'ZMW', description: 'Zambian kwacha' },
  { value: 'ZWG', description: 'Zimbabwe Gold' },
];
